define('app/views/image',['require','./baseview'],function(require){

  var BaseView = require('./baseview');

  return BaseView.extend({

    view: 'image',
    image: null,
    loaded: false,

    defaults: {
      mode: 'cover', //'cover' or 'contain'
      anchor: 5, //1-9
      preload: true,
      autoResize: true,
      resizeThrottle: 250
    },

    initialize: function(options){
      BaseView.prototype.initialize.call(this, options);

      this.$el.addClass(this.options.mode).addClass('anchor-' + this.options.anchor);

      this.image = $('img', this.$el);

      if(this.options.autoResize){
        $(window).resize(_.throttle(this.onResize, this.options.resizeThrottle));
      }
    },

    onViewLoaded: function(){
      var src = (this.image.data('src') || this.image.attr('src'));
      this.$el.css({ 'background-image': 'url("' + src + '")' });
      BaseView.prototype.onViewLoaded.call(this);
    },

    cover: function(w, h, img){
      var iw = img.width();
      if (iw != w) {
        img.width(w);
        img.css('height', 'auto');
      }

      var ih = img.height();
      if (ih < h) {
        img.height(h);
        img.css('width', 'auto');
      }

      this.anchor.call(this, w, h);
    },

    contain: function(w, h, img){
      var iw = img.width();
      if (iw != w) {
        img.width(w);
        img.css('height', 'auto');
      }

      var ih = img.height();
      if (ih > h) {
        img.height(h);
        img.css('width', 'auto');
      }

      this.anchor.call(this, w, h);
    },

    anchor: function(w, h){
      if(this.anchors[(this.options.anchor || 0)]){
        this.anchors[this.options.anchor].call(this, w, h);
      } else {
        console.log('could not find anchor mode: ' + this.options.anchor);
      }
    },

    anchors: [
      function(w, h){},

      //top left
      function(){
        this.image.css({ top: 0, left: 0 });
      },

      //top center
      function(w){
        var left = (w - this.image.width()) / 2;
        this.image.css({ top: 0, left: left });
      },

      //top right
      function(){
        this.image.css({ top: 0, right: 0 });
      },

      //left center
      function(h){
        var top = (h - this.image.height()) / 2;
        this.image.css({ top: top, left: 0 });
      },

      //center center
      function(w, h){
        var left = (w - this.image.width()) / 2;
        var top = (h - this.image.height()) / 2;
        this.image.css({ top:top, left:left });
      },

      //right center
      function(w, h){
        var top = (h - this.image.height()) / 2;
        this.image.css({ top: top, right: 0 });
      },

      //left bottom
      function(){
        this.image.css({ bottom: 0, left: 0 });
      },

      //center bottom
      function(w){
        var left = (w - this.image.width()) / 2;
        this.image.css({ bottom: 0, left: left });
      },

      //right bottom
      function(){
        this.image.css({ bottom: 0, right: 0 });
      }
    ],

    onResize: function(e){
      if(this.image && this.image.is(':visible')) {
        if(this[this.options.mode]){
          this[this.options.mode].call(this, this.$el.width(), this.$el.height(), this.image);
        } else {
          console.log('no resize function for mode: ' + this.options.mode);
        }
      }
    }

  });

});
